import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpDataService, LocalesService } from '../../core';
import { Payment } from '../models/payment';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class PaymentsService extends HttpDataService {
  public stripePublicKey: string;
  public purchasingPackages: any[];

  constructor(protected injector: Injector, public locales: LocalesService) {
    super(injector, '');
  }

  getPublicKey(): Observable<string> {
    if (this.stripePublicKey) {
      return of(this.stripePublicKey);
    }
    return this.http.get<string>(`${this.baseUrl}/payments/`).pipe(
      map((response) => {
        this.stripePublicKey = response;
        return this.stripePublicKey;
      }),
      catchError((error) => this.handleObservableError(error))
    );
  }

  getOrderPackages(): Observable<any[]> {
    if (this.purchasingPackages) {
      return of(this.purchasingPackages);
    }
    return this.http.get<any>(`${this.baseUrl}/subscriptions/packages/`).pipe(
      map((response) => {
        this.purchasingPackages = response;
        return this.purchasingPackages;
      }),
      catchError((error) => this.handleObservableError(error))
    );
  }

  orderCredits(payment: Payment): Observable<any> {
    const url = `${this.baseUrl}/subscriptions/${payment.clientId}/order/`;
    return of(super.postRequest(url, JSON.stringify(payment), this.getRequestOptions()));
  }

  getClientRegisterConfig(): Observable<any> {
    return this.http.get(`${this.baseUrl}/payments/register/config`);
  }

  createPayment(paymentData: any) {
    return this.http.post(`${this.baseUrl}/payments/`, paymentData);
  }

  orderCreditsClient(orderData: any) {
    const url = `${this.baseUrl}/subscriptions/`;
    return this.http.post(url, orderData);
  }

  createPaymentIntent(intentData: any) {
    return this.http.post(`${this.baseUrl}/payments/intent`, intentData);
  }

  createCustomerAndSubscription(data: any) {
    return this.http.post(`${this.baseUrl}/payments/customers`, data);
  }
}
